// This file contains the shared libraries which will be injected in the page and be common to all Frontends
import React from "react"
import ReactDOM from "react-dom"
import axios from "axios"
import promisePolyfill from "es6-promise"

window.React = React
window.ReactDOM = ReactDOM

// axios needs a polyfill promise to work in older browsers
promisePolyfill.polyfill()
window.axios = axios
